window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.facetWrapper = `
    <style>
        .open-filter .filter-link {
            background: url(/images/arrow-up-grey.svg) no-repeat right center;
        }

        .filter-link {
            display: block;
            font-size: 16px;
            line-height: 29px;
            letter-spacing: .15px;
            color: #2f2f2f;
            padding: 10px 20px 10px 0;
            background: url(/images/arrow-down-grey.svg) no-repeat right center;
        }

        hawksearch-checkbox-list-facet {
            display: none;
        }

        .open-filter hawksearch-checkbox-list-facet {
            display: block;
        }
    </style>
    {{#unless (eq title "In Stock Branches")}}
    {{#unless (eq title "Featured Product Group Id")}}
    <div class="filter-block">
        <div>
            <span class="filter-link" onclick="hawksearchProductListing.toggleFilterFacet(event); return false;">{{title}}</span>
            {{#if (eq type "checkbox")}}
            <hawksearch-checkbox-list-facet hawksearch-facet></hawksearch-checkbox-list-facet>
            {{/if}}
        </div>
    </div>
    {{/unless}}
    {{/unless}}
`;
